// config.js
const getApiBaseUrl = () => {
  const { hostname, port } = window.location;
  
  // Development environments
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://${hostname}/api`;
  }
  
  // Production environment
  if (hostname === 'tiktactok.cr8tiv.com') {
    return 'https://tiktactok.cr8tiv.com/api';
  }
  
  // Fallback
  return 'http://localhost/api';
};

export const API_BASE_URL = getApiBaseUrl();